






















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'Tooltip',
  props: {
    placement: {
      type: String as PropType<
        'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
      >,
      default: 'top-right',
    },
    minWidth: {
      type: String,
      default: '250px',
    },
    isAttention: {
      type: Boolean,
      default: false,
    },
  },
});
